import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import AOS from "aos";
import banner1 from "../assets/banner1.jpg";
import logo from "../assets/logo.png";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (ready) AOS.refresh();
  }, [ready]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section
      className="MainBodySection py-5 fr-hero-shell"
      style={{
        backgroundImage: `linear-gradient(130deg, rgba(4, 4, 6, 0.88), rgba(12, 13, 16, 0.9)), url(${banner1})`,
      }}
    >
      <div className="container py-4 py-lg-5">
        <div className="row justify-content-center text-center">
          <div className="col-lg-10 col-xl-9">
            <img src={logo} width={250} alt="DOUBLE F SMART ENERGIES ENTERPRISE logo" className="fr-hero-logo" data-aos="fade-up" />
           
            <p className="fr-kicker mb- text-primary fs-1 font-smi-bold" data-aos="fade-up" data-aos-delay="80">
              Let there be light
            </p>
            <p className="text-light mb-5 mx-auto fr-hero-copy font-semi-bold fs-5" data-aos="fade-up" data-aos-delay="140">
              A renewable energy solutions company delivering clean, practical and affordable power
              systems for homes, businesses and institutions across Africa.
            </p>
            <div className="d-flex flex-wrap gap-3 justify-content-center" data-aos="fade-up" data-aos-delay="220">
              <button
                className="btn fr-hero-btn fr-hero-btn-primary px-4 py-2"
                onClick={() => appContext.navTo({ item: "services" })}
              >
                <span>Explore Solutions</span> <IoMdArrowDropright size={22} />
              </button>
              <button
                className="btn fr-hero-btn fr-hero-btn-ghost px-4 py-2"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                <span>Contact Us</span> <IoMdArrowDropright size={22} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
